import React from 'react';

import './Footer.scss';

interface SocialNavigationItem {
  className: string;
  title: string;
  href: string;
}

interface FooterNavigationItem {
  title: string;
  href: string;
}

const footerNavigationItems: FooterNavigationItem[] = [{
  title: 'Privacy Policy',
  href: 'http://www.harpercollinschristian.com/privacy/',
}, {
  title: 'Terms of Use',
  href: 'http://www.harpercollinschristian.com/terms/',
}, {
  title: 'California Privacy Rights',
  href: 'https://www.harpercollinschristian.com/california-consumer-privacy-act/',
}, {
  title: 'Do Not Sell My Personal Information',
  href: 'https://www.harpercollinschristian.com/do-not-sell/',
}];

const socialNavigationItems: SocialNavigationItem[] = [{
  className: 'facebook',
  title: 'Facebook',
  href: 'https://www.facebook.com/AdventureBible',
}, {
  className: 'instagram',
  title: 'Instagram',
  href: 'https://www.instagram.com/adventurebible/',
}, {
  className: 'pinterest',
  title: 'Pinterest',
  href: 'https://www.pinterest.co.uk/Adventure_Bible/',
}];

const Footer = (): React.ReactElement => (
  <footer id="footer" className="footer container">
    <nav className="nav">
      <ul className="list social">
        {socialNavigationItems.map(({ className, title, href }) => (
          <li className={`menu-item ${className}`} key={title}>
            <a
              className="link"
              href={href}
              rel="noreferrer"
              target="_blank"
              title={title}
            >
              {title}
            </a>
          </li>
        ))}
      </ul>

      <ul className="list">
        {footerNavigationItems.map(({ title, href }) => (
          <li className="menu-item" key={title}>
            <a
              className="link"
              href={href}
              rel="noreferrer"
              target="_blank"
              title={title}
            >
              {title}
            </a>
          </li>
        ))}
      </ul>
    </nav>

    <div className="copyright">
      {`Copyright ${(new Date().getFullYear())} HarperCollins Publishers. All Rights Reserved`}
    </div>
  </footer>
);

export default Footer;
